import { useState, type ReactNode } from 'react';
import { App, Button, Popconfirm } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { errorMessage } from '../api/client';
import { plural } from '../utils/format';

/** Export button that asks before downloading; `count` (with `noun`) says how many rows the file will hold. */
export function ExportButton({ onExport, count, noun = 'record', children = 'Export' }: { onExport: () => Promise<unknown>; count?: number; noun?: string; children?: ReactNode }) {
  const { message } = App.useApp();
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await onExport();
    } catch (e) {
      message.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Popconfirm
      title="Export to CSV?"
      description={count === undefined ? 'The current view is downloaded as a CSV file.' : `${plural(count, noun)} will be downloaded as a CSV file.`}
      okText="Export"
      placement="bottomRight"
      onConfirm={() => void run()}
    >
      <Button icon={<DownloadOutlined />} loading={busy}>
        {children}
      </Button>
    </Popconfirm>
  );
}
